module.exports = __webpack_public_path__ + "01ea978f/img/upload-icon.9179ae4e.svg";